import {useIntl} from 'react-intl';
import {formatCallDuration} from '../services/format';
import type {AloneAutoLeave} from './useAloneAutoLeave';
import {groupSurfaceMessages as m} from './groupMessages';

export const AloneCountdown = ({autoLeave, className = ''}: {autoLeave: AloneAutoLeave; className?: string}) => {
    const intl = useIntl();
    return (
        <div data-testid="group-call-alone-countdown" className={`flex items-center gap-2 text-[13px] font-medium text-[var(--phq-call-ink-muted)] ${className}`}>
            <span role="timer" className="tabular-nums">{intl.formatMessage(m.aloneEndsIn, {time: formatCallDuration(autoLeave.remainingMs)})}</span>
            <button
                type="button"
                data-testid="group-call-alone-stay"
                onClick={autoLeave.stay}
                className="phq-call-press inline-flex h-7 items-center rounded-lg bg-[var(--phq-call-surface-muted)] px-2.5 text-xs font-semibold text-[var(--phq-call-ink)]"
            >
                {intl.formatMessage(m.aloneStay)}
            </button>
        </div>
    );
};
